module.exports = __webpack_public_path__ + "static/media/icon-team-mates.21edfb7b.svg";